// extracted by mini-css-extract-plugin
export default {"modalOverlay":"qJ-z","modalContent":"rJ-z","header":"sJ-z","close":"tJ-z"};